export * from './confirm-password.component';